import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Bypasses the Angular service worker for multipart file uploads.
 *
 * On WebKit (iOS Safari/Chrome) an active service worker re-issues the request and drops the
 * multipart body, so the backend receives no file part https://github.com/angular/angular/issues/24853.
 * Any request with a `FormData` body is a file upload, so we add the `ngsw-bypass` header to let the browser handle it directly.
 */
export const ngswBypassInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.body instanceof FormData) {
    return next(req.clone({ headers: req.headers.set('ngsw-bypass', 'true') }));
  }

  return next(req);
};
